export enum NavigationPosition {
  FOOTER_HELP = 'footer_help',
  FOOTER_ACCOUNT = 'footer_account',
  FOOTER_COMPANY = 'footer_company',
  USER_LEFT = 'user_left',
  GUEST_LEFT = 'guest_left',
  HOME_PAGE = 'home_page'
}
